module.exports = __webpack_public_path__ + "img/grin-tears.07bb93e0.svg";